var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _path16, _g12, _path17, _g13, _path18, _g14, _path19, _g15, _path20, _g16, _path21, _g17, _path22, _g18, _path23, _g19, _path24, _g20, _path25, _g21, _path26, _g22, _path27, _g23, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_302845)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#DCC0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.2 0C344.2 38 260.1 49.8 236.3 93.7C176.1 204.8 103 204.4 0 194.7V0H356.2Z",
    fill: "#DDB19E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500 287.2V500H0V417.4C99.7 331 238.3 418.2 500 287.2Z",
    fill: "#DDB19E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.3 417.2C350.588 417.2 410 390.651 410 357.9C410 325.15 350.588 298.6 277.3 298.6C204.012 298.6 144.6 325.15 144.6 357.9C144.6 390.651 204.012 417.2 277.3 417.2Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 302.2C110.5 331.6 128.6 360.2 154.4 376.3C194 401.1 244.5 397.4 288.5 387C426.6 355.6 498.4 222.6 395.2 108.3C385.6 97.8001 375.1 88.1001 364 79.0001C363.5 78.6001 363.4 77.8001 363.8 77.3001C364.2 76.8001 364.9 76.7001 365.4 77.1001C394.9 98.2001 421.3 124.8 438.3 157.1C472 220.5 458.9 292.8 410.8 345C377.6 381.4 332.2 405.2 284.9 417.3C236.3 429.7 181.6 432 136.5 406.2C101 386 75.8 350.1 66.2 310.7C63.1 299.5 70.4 287.7 82 285.9C92.8 284.2 103 291.5 104.8 302.2Z",
    fill: "#FFE600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M402.7 223.3C406.1 309.6 327.8 383.6 226.7 361.8C125.6 340 84.7 240.3 123.4 163.1L402.7 223.3Z",
    fill: "#6F5BA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.9 294.4C381.7 294.4 382.6 294.5 383.4 294.5C382.6 283.7 383.2 272.8 385 262C384.2 261.8 383.4 261.7 382.6 261.5C380.7 272.3 380.1 283.4 380.9 294.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.9 292.5C353.7 292.6 354.6 292.7 355.4 292.7C353.9 280 354.3 267.2 356.5 254.7C355.7 254.5 354.9 254.2 354.1 254C351.9 266.7 351.5 279.6 352.9 292.5Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254 306.7C247.8 293.7 243.7 280 241.8 266.2C240.9 265.9 240 265.5 239.2 265.1C241 279.7 245.2 294.1 251.8 307.8C260.8 326.6 273.5 342.7 289.3 355.6C290.7 355.7 292.1 355.7 293.5 355.8C276.7 342.7 263.3 326.1 254 306.7Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197 292C188.8 274.9 184.4 256.7 183.7 238.4C182.8 237.9 182 237.5 181.1 237C181.6 256.1 186.1 275.2 194.7 293.1C205.6 315.8 221.9 334.6 242.5 348.6C244.5 348.9 246.5 349.2 248.5 349.5C226.2 335.5 208.5 316 197 292Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.5 284.7C158.7 264.3 154.3 242.4 155.2 220.7C154.4 220.2 153.6 219.6 152.8 219.1C151.6 241.7 156.1 264.6 166.3 285.8C178.7 311.6 198.2 332.4 222.9 346.8C224.7 346.8 226.5 346.9 228.4 347C202 332.8 181.4 311.5 168.5 284.7Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 277.4C128.6 253.6 124.5 227.7 127.6 202.4C126.8 201.8 126.1 201.2 125.3 200.6C121.7 226.8 125.8 253.8 137.7 278.5C152.6 309.6 177.7 333.4 210 347.5C211.7 347.2 213.4 347 215 346.9C181.4 333.2 155.3 309.2 140 277.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.5 314C276.6 301.6 272.6 288.7 270.6 275.6C269.7 275.3 268.8 275.1 268 274.8C270 288.6 274.1 302.1 280.3 315.1C287.6 330.3 297.3 343.7 309.2 355.2C310.3 355.1 311.3 354.9 312.4 354.8C300 343.2 289.9 329.5 282.5 314Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.5 299.3C218.3 284.3 214 268.5 212.6 252.5C211.7 252.1 210.9 251.7 210 251.3C211.3 268 215.7 284.6 223.3 300.4C233.4 321.4 248.1 339 266.6 352.7C268.4 353 270.3 353.3 272.1 353.6C252 339.8 236.1 321.5 225.5 299.3Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.4 294.5C382.6 294.5 381.7 294.4 380.9 294.4C381.2 299.3 381.8 304.1 382.7 309C383.4 308.2 384.1 307.5 384.8 306.7C384.2 302.6 383.7 298.5 383.4 294.5Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.4 292.7C354.6 292.6 353.7 292.5 352.9 292.5C354.3 304.9 357.4 317.2 362.2 329C362.9 328.4 363.5 327.8 364.2 327.2C359.7 316 356.8 304.4 355.4 292.7Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.5 328.6C333.4 315.9 329.4 302.7 327.5 289.2C326.6 289.1 325.8 288.9 324.9 288.8C326.8 302.8 331 316.5 337.3 329.7C339.5 334.2 341.8 338.5 344.4 342.7C345.1 342.3 345.9 341.9 346.6 341.5C344 337.4 341.6 333.1 339.5 328.6Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311 321.3C305.2 309.2 301.3 296.5 299.2 283.6C298.3 283.4 297.4 283.2 296.6 283C298.6 296.4 302.7 309.7 308.7 322.4C313.3 332 318.9 340.9 325.4 349C326.3 348.8 327.2 348.6 328.1 348.4C321.5 340.2 315.7 331.1 311 321.3Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.9 244.1C262.1 243.9 261.3 243.7 260.5 243.4C252.6 265.3 238.9 285 220.4 300.6C203.4 314.9 183.8 324.6 162.5 329.5C163 330 163.6 330.5 164 331.1C164.3 331.2 164.6 331.4 165 331.5C185.9 326.4 205.2 316.7 222 302.5C240.9 286.6 254.8 266.5 262.9 244.1Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318 263.8C317.2 263.5 316.4 263.2 315.7 262.9C307.6 282.9 294.6 300.9 277.4 315.3C258.1 331.5 235.3 341.8 210.7 345.9C212.1 346.5 213.6 347.1 215 347.7C238.6 343.2 260.4 332.9 279 317.2C296.5 302.5 309.7 284.1 318 263.8Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.7 253.5C289.9 253.2 289.1 252.9 288.4 252.6C280.4 273.8 267 292.8 249 307.9C230.4 323.6 208.6 333.7 184.9 338.1C186 338.6 187 339.3 187.7 340.1C210.9 335.4 232.3 325.3 250.6 309.8C268.8 294.4 282.5 275 290.7 253.5Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345 274.6C344.2 274.3 343.5 274 342.7 273.7C334.5 292.3 322.1 309 305.9 322.6C285.4 339.8 261.1 350.4 234.7 353.9C236.7 354.4 238.8 355 240.8 355.5C265.4 351.2 288.1 340.8 307.5 324.5C324 310.6 336.6 293.6 345 274.6Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.2 222.8C176.4 222.6 175.6 222.4 174.8 222.2C166.8 243.8 153.3 263.3 134.9 278.7C130.3 282.5 125.6 286.1 120.6 289.2C121 289.9 121.5 290.6 121.9 291.3C126.9 288.1 131.8 284.5 136.5 280.6C155.2 264.8 169.1 244.9 177.2 222.8Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.4 329.9C313.6 347.4 288.8 358 261.8 361.4C263 361.8 264.2 362.2 265.4 362.6C265.9 362.8 266.3 363 266.8 363.2C292.4 359.2 315.9 348.6 335.9 331.8C351.2 318.9 363.3 303.3 371.6 285.9C370.8 285.6 370.1 285.2 369.3 284.9C361.2 301.9 349.4 317.3 334.4 329.9Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.8 229.8C205 229.6 204.2 229.4 203.4 229.2C195.4 250.9 181.8 270.5 163.4 286C153.5 294.3 142.7 301 131.3 306.2C131.3 306.2 131.3 306.3 131.4 306.3C132.5 306.3 134.8 306.3 135.9 306.3C135.9 306.5 135.9 306.6 135.9 306.8C146.2 301.8 156 295.5 165 287.9C183.8 272 197.7 252 205.8 229.8Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.9 214.8C148.1 214.6 147.3 214.3 146.5 214.1C138.9 235.1 126.1 254.1 108.7 269.3C109.1 270 109.5 270.8 109.9 271.5C127.9 255.8 141.1 236.4 148.9 214.8Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.3 206.2C113.5 219.7 106.5 232.4 97.6 243.8C97.9 244.7 98.2 245.7 98.5 246.6C108.1 234.7 115.6 221.3 120.6 207.1C119.8 206.7 119 206.5 118.3 206.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_20280_302845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 160,
    width: 295,
    height: 203
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M403.4 220.3C406.8 306.6 328.5 380.6 227.4 358.8C126.3 337 85.4 237.3 124.1 160.1L403.4 220.3Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_20280_302845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.5 236.6C233.7 236.4 232.9 236.2 232.1 236C224.2 257.9 210.5 277.7 192 293.3C177.8 305.2 161.8 313.9 144.6 319.3C145.3 320 146 320.6 146.6 321.3C163.7 315.8 179.5 307 193.6 295.2C212.5 279.2 226.4 259 234.5 236.6Z",
    fill: "#53447C"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M386.9 292.5C359.4 344.1 298.9 377.3 226.8 361.8C154.7 346.3 113.2 291.1 109.4 232.7C123.5 283.9 165.6 328.3 231 342.4C296.4 356.5 352.9 333.3 386.9 292.5Z",
    fill: "#53447C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.1 163.2C145.7 128.8 211.8 116.2 274.4 128.5C337 140.8 393.4 177.4 402.3 218.2C413.8 271.2 343.8 311.5 242.4 291.6C141 271.7 91.4 207.9 122.1 163.2Z",
    fill: "#F5916A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M290.6 302.6C274.7 302.6 258 300.9 241.1 297.6C209.4 291.4 180.7 280.1 158.2 265C136.8 250.6 121.3 233.2 113.4 214.6C104.4 193.3 106.1 171.5 118.1 153.1C130.6 134 153.3 120 184 112.6C212.6 105.7 245.8 105.3 277.6 111.6C309.4 117.8 340 130.7 363.9 147.9C389.5 166.3 405.3 187.9 409.6 210.3C413.8 231.8 407 252.7 390.7 269C376.4 283.3 355.5 293.6 330.2 298.7C317.8 301.4 304.5 302.6 290.6 302.6ZM232.1 119.7C216.4 119.7 201 121.4 186.9 124.8C159.8 131.3 139.1 143.8 128.5 160C118.7 175 117.5 192.2 124.9 209.8C139.7 245 185.2 274 243.5 285.4C301.8 296.8 354.8 287.2 381.9 260.2C395.4 246.7 400.8 230.3 397.4 212.7C393.7 193.8 379.3 174.4 356.7 158.1C334.3 141.9 305.3 129.8 275.3 123.9C261 121.1 246.4 119.7 232.1 119.7Z",
    fill: "#D8D0E7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M395.8 235.4C396.3 230.7 396.3 231.5 395.1 226.5C386.2 190.2 332.6 154.1 273 142.8C170.1 123.3 134 165 121.7 196.1C119.8 201 119.6 175.3 124.4 168.1C147.1 134.3 216 118 275.5 129.7C335 141.4 388.7 177 396.9 216.9C398.8 225.3 398 227.8 395.8 235.4Z",
    fill: "#E06E4B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M395.8 235.4C396.3 230.7 396.3 223.9 395.1 218.8C386.2 182.5 332.5 147.2 272.9 135.5C213.3 123.8 150.3 136.2 128.3 166.4C125.2 170.6 122.6 174.4 121.2 179C122.1 171.1 125.3 164 130.2 156.8C152.9 123 216 110.3 275.6 122C335.1 133.7 388.8 169.3 397 209.2C398.8 217.7 399.3 228.2 395.8 235.4Z",
    fill: "#53447C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M324 131.7C324 131.7 320.6 127.5 296.3 131.7C272 135.9 216.6 141.8 216.6 141.8C216.6 141.8 238.2 160.5 250.6 162.7C263 164.9 323.9 164.7 323.9 164.7L324 131.7Z",
    fill: "#F5916A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M289.8 156.2C289.8 156.2 323.6 116 337.6 117.7C351.7 119.5 333.4 129.9 330.7 143.3C328.1 156.7 353.7 165.6 361.8 168.4C369.9 171.2 384.8 175.1 383.7 189.5C382.6 204 378.1 216.1 378.1 216.1L289.8 156.2Z",
    fill: "#F5916A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M340.2 164.8C340.2 164.8 395.7 151.5 402 133.1C408.3 114.7 406.5 94.5998 423.1 98.1998C439.7 101.8 409.9 139.1 409.9 139.1C409.9 139.1 371.5 183 371.5 200.5C371.5 218 340.2 164.8 340.2 164.8Z",
    fill: "#F5916A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M348.9 253.6C341.6 271.4 322.4 276.5 304.9 273.3C265.4 267.4 225.1 261.9 188.4 245.3C173.1 238.2 157.2 226 157.9 207.3C157.8 200 158.3 192.7 160.4 185.6C163.8 172.9 173.2 161.9 186.6 159.6C189 159.3 191.5 158.8 193.8 158.4C198 157.8 202.1 159.1 206.2 159.6C220 160.7 234.5 159.9 248.4 159.3C262.2 159.1 287.4 155.3 298.3 164.6L299.1 165.4L299.8 166.3C306.7 174.7 316.5 180.3 325.4 186.5C329.3 189.1 333.2 191.8 337 194.7C341 197.8 344.9 200.8 347.5 205.4C348.5 207.1 349.1 209.7 348.4 211.9C347.9 214.6 348.3 217.2 348.6 220.1C350.1 230.1 347.9 236.4 336.5 236.2C329.3 236.1 322.3 233.9 315.3 233.1C306.1 231.8 296.8 231.8 287.6 233C278.3 234.1 268.9 236.2 259.4 236.7C240.4 237.5 211.4 236.4 195.8 224.8C192.6 222.4 189.6 218.4 188.9 214.2C188.3 210.7 187.4 207 187.1 203.5C185.3 191.3 187.8 179 202.5 178.6C207 178.7 211.5 178.8 216 177.7C220.4 176.8 224.8 175.4 229.7 174.4C236.9 172.7 245.1 172.6 252.4 174.9C254.5 175.4 257.3 176.6 259.3 177.4C267.9 180.6 277.1 182.8 286 185.2C298.5 188.7 312.2 191.1 323.7 198.1C332.6 204 328.2 213 319.9 216.4C303.7 222.7 279 217.6 262.2 214.7C254.2 213.3 246.1 211.9 238 211.2C237.2 211.1 235.5 211 234.8 211C232.5 211 230.7 209.2 230.8 206.9C230.8 204.6 232.6 202.8 234.9 202.9C235.8 202.9 236.5 203.1 237.2 203.2C238.3 203.4 241.4 203.9 242.6 204.1C263.2 207.7 283.7 214 304.8 213.4C310.8 213 320.7 212.3 322.6 206.1C322.6 205.8 322.6 205.5 322.1 204.9C319.7 202.2 315 200.3 311.3 199C298.3 194.5 284.1 191.7 270.6 188.2C266 187 261.4 185.7 256.8 184C252.8 182.4 248.4 180.9 244.1 180.5C232.5 179.2 221.7 185.5 209.9 186C207.6 186.2 205.1 185.9 202.8 186C190.3 185.9 193.8 201.3 195 209.7C195.3 211.3 195.6 214.1 196.4 215.6C202.1 225.6 220.6 228.7 231.5 230.5C240.6 231.8 250 232.4 259.2 232.1C268.4 231.9 277.6 230.3 287.1 229.2C296.6 228.2 306.3 228.3 315.8 229.8C322.9 230.6 329.5 232.8 336.5 232.8C340.5 232.8 344.8 232.2 344.9 227.5C345.2 222.4 343.3 216.9 344.1 211.5L344.2 211V210.8C344.4 209.8 344.1 209 343.5 207.9C341.3 204.3 337.5 201.4 334.1 198.9C326.5 193.4 318.4 188.6 310.8 183.1C305.5 179.3 299.9 175.1 295.8 169.7C294.3 167.8 292.2 166.7 289.7 165.7C285.6 164.1 281.1 163.3 276.5 162.6C258 159.9 238.8 161.7 220.2 163.1C215.5 163.4 210.8 163.7 205.9 163.4C202.4 163.1 199 162.4 195.5 162.2C193.7 162 190.5 161.5 188.7 161.9C185.4 162.5 182 163.7 179.2 165.5C169.4 171.6 165.9 183.4 164.3 194.3C163.5 200.9 162.7 208 163.5 214.5C165.8 228.2 177.7 237.7 189.2 244.3C197.4 249 206.1 252.5 215.1 255.3C242.1 263.8 270.2 267.7 298.2 270.8C304.8 271.5 312.4 272.6 319 271.5C329.4 270.2 339.4 263.9 343.2 253.9C343.4 253.4 343.6 252.9 343.6 252.5C344.6 248.3 350.1 249.9 348.9 253.6Z",
    fill: "#F7A788"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M171.7 163.3C175.9 157.1 187.5 154.9 198.4 157C209.3 159.2 219.2 165.7 220.7 172.9C222.7 182.4 210.4 189.6 192.6 186.1C175 182.7 166.3 171.3 171.7 163.3Z",
    fill: "#F8FCFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M176.6 163.8C179.9 158.8 189.3 157 198.1 158.7C206.9 160.4 214.9 165.7 216.1 171.5C217.7 179.1 207.8 184.9 193.5 182.1C179.2 179.4 172.2 170.3 176.6 163.8Z",
    fill: "#D0E2D8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.6 165.3C184.9 161.9 191.4 160.6 197.6 161.8C203.7 163 209.3 166.7 210.1 170.7C211.2 176 204.3 180 194.4 178.1C184.4 176.1 179.5 169.8 182.6 165.3Z",
    fill: "#F8FCFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185.3 165.6C187.2 162.8 192.4 161.8 197.4 162.8C202.3 163.8 206.8 166.7 207.5 170C208.4 174.3 202.8 177.5 194.8 175.9C186.8 174.3 182.8 169.2 185.3 165.6Z",
    fill: "#D0E2D8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M271.2 235.4C274.7 227.4 287.6 222.3 300.8 222.5C313.9 222.7 326.7 228.1 330 236.2C334.3 246.7 321.6 257.7 300.3 257.4C279 257.1 266.6 245.8 271.2 235.4Z",
    fill: "#F8FCFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M276.9 234.9C279.7 228.5 290.1 224.4 300.7 224.5C311.3 224.6 321.6 229.1 324.2 235.6C327.6 244.1 317.4 252.9 300.3 252.6C283.2 252.4 273.2 243.3 276.9 234.9Z",
    fill: "#D0E2D8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.1 235.4C286.1 230.9 293.3 228.1 300.7 228.2C308 228.3 315.2 231.4 317 235.9C319.4 241.8 312.3 247.9 300.4 247.8C288.5 247.7 281.6 241.2 284.1 235.4Z",
    fill: "#F8FCFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M287.3 235.1C288.9 231.5 294.7 229.2 300.6 229.3C306.5 229.4 312.3 231.8 313.8 235.5C315.7 240.3 310 245.2 300.4 245.1C290.9 245 285.3 239.8 287.3 235.1Z",
    fill: "#D0E2D8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M198.3 243.3C199.1 235 206.5 229 214.7 229.8C223 230.6 229 238 228.2 246.2",
    fill: "#734C3A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M295.7 173.1C297.1 165.2 307.6 157.9 319.3 155.3C331 152.7 343.6 154.8 348.2 161.3C354.3 169.8 345.3 182.2 326.3 186.5C307.3 190.8 293.8 183.3 295.7 173.1Z",
    fill: "#F8FCFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M300.7 171.5C301.8 165.2 310.3 159.3 319.7 157.2C329.1 155.1 339.2 156.8 343 162C347.9 168.8 340.6 178.8 325.3 182.3C310 185.7 299.2 179.7 300.7 171.5Z",
    fill: "#D0E2D8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M307.2 170.4C308 166 313.8 161.9 320.4 160.4C327 158.9 334 160.1 336.6 163.8C340 168.5 335 175.5 324.3 177.9C313.7 180.3 306.1 176.1 307.2 170.4Z",
    fill: "#F8FCFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M310 169.5C310.6 166 315.4 162.7 320.6 161.5C325.9 160.3 331.6 161.3 333.6 164.2C336.3 168 332.3 173.6 323.7 175.6C315.2 177.4 309.1 174.1 310 169.5Z",
    fill: "#D0E2D8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M249.2 170.2C248.8 161.9 255.2 154.8 263.5 154.4C271.8 154 278.9 160.4 279.3 168.7",
    fill: "#734C3A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M356.4 198.1L355.9 195.5L360.9 198.8C363 200.1 365.7 199.6 367.1 197.5C368.4 195.4 367.9 192.7 365.8 191.3L362.2 188.9L371.2 188.7C373.6 188.7 375.6 186.6 375.6 184.2C375.6 181.8 373.5 179.8 371.1 179.8L366 179.9L369.8 175.9C371.5 174.1 371.4 171.3 369.6 169.6C367.8 167.9 365 168 363.3 169.8L357.1 176.3L357.8 172C358.2 169.6 356.5 167.3 354.1 166.9C351.7 166.5 349.4 168.2 349 170.6L348 176.5L346.5 174.4C345.1 172.4 342.3 171.9 340.3 173.4C338.3 174.8 337.8 177.6 339.3 179.6L345.4 188.1C345.5 188.2 345.5 188.3 345.6 188.4C345.6 188.8 345.6 189.2 345.7 189.6L347.9 199.8C348.4 202.2 350.8 203.7 353.2 203.2C355.4 202.9 356.9 200.5 356.4 198.1ZM355.7 183.3C355.8 183.5 356 183.6 356.1 183.7C356.1 183.7 356.2 183.7 356.2 183.8C356.2 184.1 356.1 184.3 356.1 184.6C356.1 184.8 356.1 185 356.2 185.2C355.7 185 355.2 184.9 354.7 184.9C355.1 184.5 355.5 183.9 355.7 183.3Z",
    fill: "#17964A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M333 193.1C332.6 192 333.1 190.8 334.2 190.4L356.8 181.8C357.9 181.4 359.1 181.9 359.5 183C359.9 184.1 359.4 185.3 358.3 185.7L335.7 194.3C334.6 194.7 333.4 194.2 333 193.1Z",
    fill: "#26A85A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247.8 206.6L245.4 207.7L247.4 202.1C248.2 199.8 247 197.2 244.7 196.4C242.4 195.6 239.8 196.8 239 199.1L237.6 203.2L235.3 194.5C234.7 192.1 232.2 190.7 229.9 191.3C227.5 191.9 226.1 194.4 226.7 196.7L228 201.6L223.3 198.9C221.2 197.7 218.4 198.4 217.2 200.5C216 202.6 216.7 205.4 218.8 206.6L226.6 211.1L222.3 211.4C219.9 211.6 218 213.7 218.2 216.2C218.4 218.6 220.5 220.5 223 220.3L229 219.9L227.3 221.9C225.7 223.8 225.9 226.6 227.8 228.2C229.7 229.8 232.5 229.6 234.1 227.7L240.9 219.8C241 219.7 241.1 219.6 241.1 219.5C241.5 219.4 241.9 219.3 242.3 219.1L251.7 214.6C253.9 213.5 254.9 210.9 253.8 208.7C252.7 206.5 250 205.5 247.8 206.6ZM233.6 210.7C233.7 210.5 233.8 210.4 233.9 210.2V210.1C234.2 210.1 234.4 210 234.7 210C234.9 209.9 235.1 209.9 235.3 209.8C235.2 210.3 235.3 210.9 235.4 211.4C234.9 211 234.3 210.8 233.6 210.7Z",
    fill: "#17964A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M248.5 230.6C247.6 231.2 246.3 231 245.6 230.1L232 210.2C231.4 209.3 231.6 208 232.5 207.3C233.4 206.7 234.7 206.9 235.4 207.8L249 227.7C249.6 228.6 249.4 229.9 248.5 230.6Z",
    fill: "#26A85A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 201.9C175.2 204.1 177.8 208.1 181.2 213.2C164.2 225.1 148.1 204.1 144.7 187.1C146.4 188.8 149.8 190.5 151.3 192.6C155.1 195.9 161 199.4 168.5 201.9Z",
    fill: "#17964A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M185.1 215.7C185 215.7 184.9 215.7 184.9 215.6C179.9 213.2 176 212 172.5 210.9C166.8 209.1 161.8 207.6 154.4 201.6C154.2 201.4 154.1 201.1 154.3 200.9C154.5 200.7 154.8 200.6 155 200.8C162.3 206.7 167.1 208.2 172.8 210C176.3 211.1 180.3 212.3 185.3 214.8C185.6 214.9 185.7 215.2 185.5 215.5C185.5 215.5 185.3 215.7 185.1 215.7Z",
    fill: "#26A85A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M353.3 211.5C347.3 207.8 342.6 208.5 336.5 209.2C338.5 229.8 364.9 228.5 380 220.1C377.6 219.9 374.1 218.4 371.5 218.6C366.5 217.7 360 215.5 353.3 211.5Z",
    fill: "#17964A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M362.8 222C362.7 222 362.7 222 362.8 222C353.3 220.2 348.9 217.5 343.8 214.3C340.7 212.4 337.3 210.2 332.2 208C331.9 207.9 331.8 207.6 331.9 207.3C332 207 332.3 206.9 332.6 207C337.8 209.2 341.3 211.5 344.4 213.4C349.4 216.5 353.7 219.3 362.9 221C363.2 221.1 363.4 221.3 363.3 221.6C363.2 221.8 363 222 362.8 222Z",
    fill: "#26A85A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M367.7 103.6C363.1 112.2 364.4 118.7 366 127C394.3 122.5 390.2 85.9999 377.2 65.8999C377.1 69.1999 375.4 74.1999 375.9 77.6999C375.2 84.7999 372.7 93.9999 367.7 103.6Z",
    fill: "#17964A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M363.9 133.6C363.8 133.6 363.7 133.6 363.6 133.6C363.2 133.5 363 133 363.2 132.7C365.8 125.4 368.6 120.3 371.1 115.9C375 108.7 378.4 102.6 379.9 89.6999C379.9 89.2999 380.3 88.9999 380.7 89.0999C381.1 89.0999 381.4 89.5 381.3 89.9C379.7 103.1 376.3 109.4 372.3 116.6C369.9 121 367.2 126 364.5 133.2C364.5 133.4 364.2 133.6 363.9 133.6Z",
    fill: "#26A85A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_302845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoup);
export default __webpack_public_path__ + "static/media/Soup.f86c72a2.svg";
export { ForwardRef as ReactComponent };